<template lang="pug">
  v-dialog(v-model="dialog" persistent max-width="400")
    v-card()
      v-toolbar(flat justify-end text-right)
        v-spacer
        v-toolbar-title(class="font-weight-bold mr-6" :class="cls+'--text'") KONFIRMASI
        v-spacer
      v-card-text(class="font-weight-medium text-left mt-2" ) 
        v-layout
          v-flex(lg3 md3 xs3) 
            v-icon(:color="cls" x-large) mdi-help-circle-outline
          v-flex(lg9 md9 xs9) 
            div {{ message }}
      v-card-actions(class="justify-center" )
        v-btn(:color="cls" class="mb-3" width="150px" style="font-size:10px" @click="doOK") Ya, Lanjutkan
        v-btn(outlined class="mb-3" :color="cls" width="150px" style="font-size:10px" @click="doCancel") Tidak, Batalkan

</template>
<script>
export default {
  name: "FDialogConfirm",
  props: ["value", "message", "events"],
  watch: {
    value(val) {
      this.doInitModel(val);
    }
  },
  mounted() {
    this.doInitModel(this.value);
  },
  data() {
    return {
      dialog: false,
      confirm: false,
      cls: "primary"
    };
  },
  methods: {
    doInitModel(values) {
      this.dialog = values ? values : "";
      if (this.events) {
        if (this.events == 'insert') {
          this.cls = "info";
        } else if (this.events == 'update') {
          this.cls = "warning";
        }  else if (this.events == 'delete') {
          this.cls = "error";
        } else{
          this.cls = "primary";
        }
      }
    },
    doOK() {
      this.$emit("confirm", this.events);
      this.$emit("dialog", false);
      this.$emit("ok");
      this.$emit(this.events);
    },
    doCancel() {
      this.$emit("dialog", false);
      this.$emit("no");
    }
  }
};
</script>

